import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {graphql} from 'react-apollo';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import cartQuery from 'graphql/queries/cart.gql';
import {checkPermission} from 'core/utils';
import styles from './styles.css';

@graphql(cartQuery, {
    skip: ({user}) => !user || !checkPermission(user, 'merchandising'),
})
@autobind
export default class MenuLink extends Component {
    static propTypes = {
        label: PropTypes.string,
        categories: PropTypes.array,
        user: PropTypes.object.isRequired,
        onClose: PropTypes.func.isRequired,
    };

    state = {
        filterCategoriesVisible: false,
    }

    handleFiltersToggle() {
        this.setState({filterCategoriesVisible: !this.state.filterCategoriesVisible});
    }

    renderLink(link) {
        if (link.to) return <Link to={link.to} onClick={this.props.onClose}>{link.label}</Link>;
        if (link.externalTo) return <a href={link.externalTo} target={link.target || '_self'}>{link.label}</a>;
        return <div>{link.label}</div>;
    }

    renderLinks(links) {
        const list = links.filter(link => {
            if (!link) return false;
            if (link.permissions && !checkPermission(this.props.user, link.permissions)) return false;
            return true;
        });

        if (!list.some(({to, externalTo}) => Boolean(to) || Boolean(externalTo))) return null;

        return (
            <ul>
                {list.map(link => (
                    <div key={link.label} className={styles.containerLink}>
                        <div className={styles.marker} />
                        <li className={classNames(styles.itemLink, {[styles.subitemLink]: this.props.isCollapse})}>
                            {this.renderLink(link)}
                        </li>
                    </div>
                ))}
            </ul>
        );
    }

    render() {
        const {label, categories, isCollapse} = this.props;
        if (!this.renderLinks(categories)) return false;
        return (
            <div className={classNames(styles.filters, {[styles.hidden]: !this.state.filtersVisible})}>
                {isCollapse ?
                    <div className={styles.toggle} onClick={this.handleFiltersToggle}>
                        <p className={styles.label}>{label}</p>
                        {this.state.filterCategoriesVisible
                            ? <i className='material-icons'>keyboard_arrow_up</i>
                            : <i className='material-icons'>keyboard_arrow_down</i>
                        }
                    </div>
                    : this.renderLinks(categories)
                }
                {this.state.filterCategoriesVisible && this.renderLinks(categories)}
                <hr className={styles.divider} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/header/menu-link/index.js